module.exports = __webpack_public_path__ + "img/zheda.3623235d.png";